import { z } from 'zod';
import { userSchema } from './userSchema';
import { machineSchema } from './machinesSchema';
export const workOrderSchema = z.object({
  id: z.number(),
  work_order_id_str: z.string(),
  project: z.string(),
  release: z.string(),
  release_id: z.string(),
  part_number: z.string(),
  part_length: z.number().nullable().optional(),
  process_route: z.string(),
  total_quantity: z.number(),
  current_status: z.string(),
  currentnum: z.number(),
  created_at: z.string(),
  assigned_users: z.array(userSchema),
  assigned_machines: z.array(machineSchema),
});

export const workOrderHelper =
  'Work order is a required. Please select at least one work order';
export const workOrdersSchema = z
  .array(workOrderSchema)
  .min(1, workOrderHelper);
export const workOrdersOptionalSchema = z.array(workOrderSchema).optional();

export const partOrdersHelper =
  'Part number is required. Please select at least one part.';
export const partOrdersSchema = z
  .array(
    z.object({
      part_number: z.string(),
      total_remaining: z.number(),
      part_length: z.string().nullable().optional(),
      master_file: z.string().nullable().optional(),
    }),
  )
  .min(1, partOrdersHelper);
export const partOrdersOptionalSchema = z.array(partOrdersSchema).optional();
export const processRouteOptionalSchema = z.string().optional();
